export const ROOT_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
};

export const TITLE_SX = {
  color: '#FFFFFF',
  margin: '32px 0',
  fontSize: '1.5rem',
};
